import { store } from "./redux/store/store";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Home/Index";
import ReportPage from "./pages/ReportPages";
import { fass } from "@fortawesome/sharp-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import mixpanel from "mixpanel-browser";
import { useEffect, createContext, useContext } from "react";
import DeleteAccount from "./component/deletePage";
import { logEvent } from './utils/events'
import { AppContext } from './util'

const { VITE_MIXPANEL_TOKEN } = import.meta.env;

library.add(fass, fab);
function App() {

  const urlParams = new URLSearchParams(window.location.search);
  // Get the values of 'userId' and 'pageId' from the query parameters
  const userId = urlParams.get("userId");
  const pageId = urlParams.get("pageId");

  useEffect(() => {
    if (VITE_MIXPANEL_TOKEN){
      mixpanel.init(VITE_MIXPANEL_TOKEN, { debug: true});
      // Commenting this out for now as it causes a runtime error
      mixpanel.track("Stack Viewed", {
        stack_id: pageId,
        distinct_id: userId,
      })
    }

    logEvent({
      type: 'page/view',
      userId,
      pageId,
    })

  }, []);
  
  return (
    <AppContext.Provider
      value={{pageId, userId}}
    >
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index pageId={pageId} />} />
            <Route path="/web/report" element={<ReportPage />} />
            <Route path="/deleteaccount" element={<DeleteAccount/>} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </AppContext.Provider>
  );
}

export default App;
